<template>
  <b-card no-body class="flex-fill">
    <b-card-header class="py-3 d-flex justify-content-between align-items-center">
      <h4 class="mb-0"><strong>{{ $t('rewards.how-to-earn') }}</strong></h4>
    </b-card-header>
    <!-- Point System Collapse -->
    <b-collapse id="point-system-description" visible accordion="point-system-accordion" role="tabpanel">
      <b-card-body>
        <template v-for="(score, key) in this.scores">
          <div :class="{
            'point-type pb-3 d-flex justify-content-start': true,
            'align-items-start': score.dailyMaximum || score.weeklyMaximum,
            'align-items-center': !score.dailyMaximum && !score.weeklyMaximum
          }" :key="`${key}-${score.id}`">
            <div class="icon-container h5 mx-3 mb-0">
              <div class="bg-primary-a2 round-icon text-center" v-if="score.icon">
                <font-awesome-icon :icon="score.icon"/>
              </div>
            </div>
            <div>
              <span>
                <b>{{ score.value }} {{ $t('rewards.tokens') }}</b> earned for <b>{{ score.label }}</b>
              </span>
              <span v-if="score.description">
                <br>{{ score.description }}
              </span>
              <span v-if="score.dailyMaximum" class="text-muted">
                <br>You can earn a maximum of <b>{{ score.dailyMaximum }} {{ $t('rewards.tokens') }}</b> per day for this activity.
              </span>
              <span v-if="score.weeklyMaximum" class="text-muted">
                <br>You can earn a maximum of <b>{{ score.weeklyMaximum }} {{ $t('rewards.tokens') }}</b> per week for this activity.
              </span>
            </div>
          </div>
        </template>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  props: {
    scores: {
      type: Array,
      required: true,
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/rewards/HowToEarnTokens.vue